<div class="mt-4 mb-4">
    <div class="input-group">
        <input type="file" class="form-control" id="uploadFile"
            aria-describedby="uploadFile" aria-label="Upload" (change)="onFileChange($event)">
        <button class="btn btn-primary" type="button"
            id="uploadFile" (click)="submitFile()" *ngIf="fileResult"><i class="bx bx-loader bx-spin font-size-16 align-middle me-2" *ngIf="loading"></i>Upload</button>
    </div>
</div>
